<template>
    <crud-facecade
        ref="video-list"
        :url="url"
        :columns="columnList"
        :buttons="[]"
        :tableHeight="tableHeight"
        v-wechat-title="title"
        :addButton="{ enabled: false, permission: 'default' }"
        :deleteButton="{ enabled: false, permission: 'default' }"
        :updateButton="{ enabled: false, permission: 'default' }"
        @DeleteVideo="DeleteVideo"
    >
        <template slot="filter-after">
            <el-upload
                ref="upload"
                :show-file-list="true"
                :action="actionVal"
                accept=".mp4"
                :limit="1"
                :before-upload="beforeUpload"
                :on-success="handleFileSuccess"
                :on-error="handleUploadError"
                :headers="{ Authorization: `bearer ${token}` }"
            >
                <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <!-- <el-progress v-show="showProgress" :stroke-width="16" :percentage="progressPercent"></el-progress> -->
        </template>
        <template slot="file_name1" slot-scope="{ row }"
            ><el-link :href="downloadFile(row)">
                {{ row.file_name }}
            </el-link>
        </template>
        <template slot="file_size1" slot-scope="{ row }"
            ><div>
                {{ (Number(row.file_size) / 1024).toFixed(2) }}
            </div>
        </template>
    </crud-facecade>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `BoardVideo`,
    props: {},
    data() {
        return {
            title: `大屏视频`,
            // progressPercent: 0,
            actionVal: `${this.$root.BASE_URL}api/AcisSystem/BoardVideoInfo/PostFiles?extensionsType=VeidoExtensions`,
            fileUploadConfig: this.$root.FileUploadConfig,
            showProgress: false,
            fileTypes: ``,
            url: {
                baseURL: `/api/AcisSystem/BoardVideoInfo`,
                get: paras => {
                    return this.ReloadData()
                },
                post: row => {

                },
                getOne: row => {
                    return this.loadOne(row)
                },
                put: row => {
                    if (!row.file_name || row.file_name.trim() == ``) {
                        this.$message.error(`文件名必填！`)
                        return
                    }
                    return new Promise((resolve, reject) => {
                        let req = this.myaxios.put(`/api/AcisSystem/BoardVideoInfo/put`, row)
                        req.then(data => {
                            resolve(data)
                        }).catch(e => reject(e))
                    })
                },
                putMany: data => {

                }

            },
            dataFile: {},
            buttons: []

        }
    },
    created() {

    },
    mounted() {

    },
    computed: {
        ...mapGetters([
            `screenHeight`
        ]),
        token() {
            return sessionStorage.getItem(`token`)
        },
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `custom`,
                    prop: `file_name1`,
                    label: `文件名`,
                    isListable: true,
                    isCreatable: false,
                    isEditable: false
                },
                {
                    type: `string`,
                    prop: `file_name`,
                    label: `文件名`,
                    isListable: false,
                    isCreatable: true,
                    isEditable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `custom`,
                    prop: `file_size1`,
                    label: `文件大小(MB)`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `creator`,
                    label: `上传人`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `create_date`,
                    label: `上传时间`,
                    width: `200`,
                    isListable: true
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    fixed: `right`,
                    label: `操作`,
                    width: `200`,
                    isListable: true,
                    readonly: false,
                    options: function(that, { row }) {
                        return [
                            {
                                class: `is-plain`,
                                label: `删除`,
                                icon: ``,
                                type: `danger`,
                                emit: `DeleteVideo`,
                                permission: `surgery_list:reject`
                            },
                            {
                                class: `is-plain`,
                                label: `编辑文件名`,
                                icon: ``,
                                type: `primary`,
                                emit: `LoadingUpdateView`,
                                permission: `default`
                            }
                        ]
                    }
                }
            ]
        }
    },
    methods: {
        ReloadData() {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/BoardVideoInfo/Get`)
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        loadOne(row) {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/BoardVideoInfo/Get/${row.id}`)
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        saveOne(row) {

        },
        // 上传前校验
        beforeUpload(file) {
            let fileconfig = JSON.parse(this.fileUploadConfig)
            let veidoExtensions = fileconfig && fileconfig.VeidoExtensions ? fileconfig.VeidoExtensions.split(`,`) : []
            let maxSize = Number(fileconfig.MaxSize) * 1024 * 1024

            if (!(file.size < maxSize)) {
                this.showProgress = false
                this.$message.error(`上传文件大小大小不能超过[${fileconfig.MaxSize}]MB!`)
                return false
            }
            let filetype = file.name.split(`.`).slice(-1)[0].toLowerCase()
            if (!_.includes(veidoExtensions, `.` + filetype)) {
                this.showProgress = false
                this.$message.error(`上传文件只能是[${fileconfig.VeidoExtensions}]格式!`)
                return false
            }
        },
        DeleteVideo({ row }) {
            this.$confirm(`是否确认删除?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `error`
            }).then(() => {
                let req = this.myaxios.delete(`/api/AcisSystem/BoardVideoInfo/DeleteFile/${row.id}?fileName=${row.file_address}`)
                req.then(data => {
                    this.$message.success(`删除成功`)
                    this.$refs[`video-list`].ReloadListData()
                })
            }).catch(() => {})
        },
        handleFileSuccess(response, file, fileList) {
            this.$message.success(`上传成功`)
            this.$refs.upload.clearFiles()
            this.$refs[`video-list`].ReloadListData()
        },
        handleUploadError() {
            this.$message({
                type: `error`,
                message: `上传失败`
            })
            this.$refs.upload.clearFiles()
            this.$refs[`video-list`].ReloadListData()
        },
        downloadFile(row) {
            return `${this.$root.BASE_URL}api/AcisSystem/BoardVideoInfo/DownloadFile?fileName=${row.file_name}&fileAddress=${row.file_address}`
        }
    },
    watch: {

    }
}
</script>
<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/Board/BoardVideo.vue